import { Locale } from "../config";
import en from "@/public/locales/locale-en.json";
import ru from "@/public/locales/locale-ru.json";
import kz from "@/public/locales/locale-kk.json";
import uz from "@/public/locales/locale-uz.json";
import { AbstractIntlMessages } from "use-intl";

export const messages: Record<Locale, AbstractIntlMessages> = {
  en,
  ru,
  kz,
  uz,
};
